/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Heading, DisplayHtmlContent, FlexRow, FlexCol, Text } from 'sarsaparilla';
import VenueTabWrapper from './VenueTabWrapper';

export default function GettingHereShared({
    permitId,
    longitude,
    latitude,
    drivingDirections,
    gpsCoordinates,
    isVehicle,
    isLegacy,
}) {
    const sharedContent = () => {
        return (
            <>
                <FlexRow>
                    {gpsCoordinates ? (
                        <DisplayHtmlContent html={gpsCoordinates} />
                    ) : (
                        <>
                            <FlexCol md={4}>
                                <Heading
                                    headingLevel={2}
                                    appearance="h5"
                                    className="mb-2"
                                >
                                    GPS Coordinates
                                </Heading>
                            </FlexCol>
                            <FlexCol className="permit-venue-right-col">
                                <Text>{`Latitude ${latitude}`}</Text>
                                <Text>{`Longitude ${longitude}`}</Text>
                            </FlexCol>
                        </>
                    )}
                </FlexRow>
                <FlexRow>
                    <FlexCol md={4}>
                        <Heading headingLevel={2} appearance="h5" className="mb-2">
                            Driving Directions
                        </Heading>
                    </FlexCol>

                    <FlexCol className="permit-venue-right-col">
                        <DisplayHtmlContent html={drivingDirections} />
                    </FlexCol>
                </FlexRow>{' '}
            </>
        );
    };
    return isLegacy ? (
        <>{sharedContent()}</>
    ) : (
        <VenueTabWrapper permitId={permitId} isVehicle={isVehicle}>
            {sharedContent()}
        </VenueTabWrapper>
    );
}

GettingHereShared.propTypes = {
    permitId: PropTypes.string,
    longitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    latitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    drivingDirections: PropTypes.string,
    gpsCoordinates: PropTypes.string,
    isVehicle: PropTypes.bool,
    isLegacy: PropTypes.bool,
};
